import { Injectable } from '@angular/core';
import { UserDto } from '../../../auth/user.dto';
import { TPermission, TPermissionContext } from '../permissions';
import { ContractEngagmentPermissionService } from './contract-engagement-permission.service';
import { ContractPermissionService } from './contract-permission.service';
import { HopayraPermissionService } from './hopayra-permision.service';
import { InboxPermissionService } from './inbox-permission.service';
import { IPermissionService } from './permission.service.interface';
import { RsjInstructionPermissionService } from './rsj-instruction-permission.service';
import { RsjPermissionService } from './rsj-permission.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionService implements IPermissionService<any> {
  constructor(
    private readonly contractPermission: ContractPermissionService,
    private readonly inboxPermission: InboxPermissionService,
    private readonly rsjPermission: RsjPermissionService,
    private readonly hopayraPermission: HopayraPermissionService,
    private readonly rsjInstructionPermission: RsjInstructionPermissionService,
    private readonly contractEngagmentPermissionService: ContractEngagmentPermissionService,
  ) {}

  public getPermissions(user: UserDto, subject: any, context: TPermissionContext): TPermission[] {
    if (user) {
      switch (context) {
        case 'CONTRACT_IER':
          return this.contractPermission.getPermissions(user, subject);
        case 'CONTRACT_SOCIO_PRO':
          return this.contractPermission.getPermissions(user, subject);
        case 'INBOX':
          return this.inboxPermission.getPermissions(user);
        case 'BENEFICIARY_RSJ':
          return this.rsjPermission.getPermissions(user);
        case 'HOPAYRA_RSJ':
          return this.hopayraPermission.getPermissions(user);
        case 'RSJ_INSTRUCTION':
          return this.rsjInstructionPermission.getPermissions(user, subject);
        case 'CE':
        case 'CE_REPRISE':
          return this.contractEngagmentPermissionService.getPermissions(user, subject);
        default:
          return [];
      }
    }
  }
}
